import React, { useMemo } from "react";
import MasterDataFormV2 from "../../MasterDataFormV2";
import { useUser } from "contexts/v1/masterData/UserContext";
import { useShifts } from "../../master/context/ShiftsContext";
import UserSelector from "./UserSelector";
import { formatDateToLocal } from "utils/utils";

const BatchAssignSchedulePage = ({ onSuccess, onError, initialUserIds = [] }) => {
  const { users } = useUser();
  const { shifts } = useShifts();

  // Create options from hooks data
  const shiftOptions = shifts.data?.map(shift => ({
    value: shift.id,
    label: shift.name
  })) || [];

  const fields = useMemo(() => [
    {
      name: "shift_id",
      label: "Shift",
      type: "select",
      required: true,
      options: shiftOptions,
      placeholder: "Select shift",
    },
    {
      name: "start_date",
      label: "Start Date",
      type: "date",
      required: true,
      defaultValue: formatDateToLocal(new Date()), // Today's date
    },
    {
      name: "end_date",
      label: "End Date",
      type: "date",
      required: true,
      defaultValue: formatDateToLocal(new Date()), // Today's date
    },
    {
      name: "is_day_off",
      label: "Is Day Off",
      type: "checkbox",
      required: false,
      defaultValue: false,
    },
    {
      name: "status",
      label: "Status",
      type: "select",
      required: true,
      options: [
        { value: "draft", label: "Draft" },
        { value: "published", label: "Published" },
      ],
      defaultValue: "draft",
    },
    {
      name: "user_ids",
      label: "Select Employees",
      type: "custom",
      required: true,
      defaultValue: initialUserIds,
      render: ({ value, onChange }) => (
        <UserSelector 
          value={value} 
          onChange={onChange} 
          users={users.data || []} 
        />
      )
    },
  ], [users.data, shiftOptions]);

  return (
    <MasterDataFormV2
      apiUrl="/ahr/schedules/assign-batch"
      initialData={null}
      fields={fields}
      onSuccess={onSuccess}
      onError={onError}
      submitButtonText="Assign Schedules"
    />
  );
};

export default BatchAssignSchedulePage;